import { gql } from "@apollo/client";

const ADD_IIA = gql`
  mutation addIIA($iiaData: IiaInput!) {
    addIIA(iiaData: $iiaData)
  }
`;

export default ADD_IIA;
